"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PageTitle = _interopRequireDefault(require("../../PageTitle/PageTitle"));
var _PageLead = _interopRequireDefault(require("../../PageLead/PageLead"));
var _PageSubLead = _interopRequireDefault(require("../../PageSubLead/PageSubLead"));
var _PageActions = _interopRequireDefault(require("../../PageActions/PageActions"));
var _PageMedia = _interopRequireDefault(require("../../PageMedia/PageMedia"));
var _getColor = require("../../../../common/getColor");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-page-top {\n  display: flex;\n  flex-direction: column; }\n  .sia-page-top .container {\n    display: flex;\n    justify-content: center;\n    flex-direction: row;\n    width: 900px;\n    max-width: 100%; }\n    .sia-page-top .container div {\n      max-width: 100%; }\n    .sia-page-top .container.no-media {\n      padding-top: 48px; }\n\n@media (max-width: 66rem) {\n  .sia-page-top .container {\n    flex-direction: column;\n    align-items: center;\n    align-self: center;\n    width: 492px; }\n    .sia-page-top .container .title-container {\n      align-self: start; } }\n\n@media (max-width: 42rem) {\n  .sia-page-top .container {\n    flex-direction: column;\n    align-items: center;\n    width: 492px;\n    align-self: center; }\n    .sia-page-top .container .title-container {\n      align-self: start; } }\n";
  const fileName = "SIAPageTop_SIAPageTop";
  const element = document.querySelector("style[data-sass-component='SIAPageTop_SIAPageTop']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIAPageTop = _ref => {
  let {
    title,
    lead,
    subleads,
    media,
    lang,
    bgColor
  } = _ref;
  const backgroundColor = (0, _getColor.getColor)(bgColor);
  const container = media ? 'container' : 'container no-media';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-page-top",
    style: {
      backgroundColor
    }
  }, media && /*#__PURE__*/_react.default.createElement(_PageMedia.default, media), /*#__PURE__*/_react.default.createElement("div", {
    className: container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title-container"
  }, /*#__PURE__*/_react.default.createElement(_PageTitle.default, null, title)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_PageLead.default, null, lead), subleads?.map((sublead, key) => /*#__PURE__*/_react.default.createElement(_PageSubLead.default, {
    key: key,
    lang: lang
  }, sublead)), /*#__PURE__*/_react.default.createElement(_PageActions.default, null))));
};
SIAPageTop.propTypes = {
  title: _propTypes.default.string.isRequired,
  lead: _propTypes.default.string.isRequired,
  subleads: _propTypes.default.array,
  lang: _propTypes.default.string.isRequired,
  bgColor: _propTypes.default.string,
  media: _propTypes.default.object
};
var _default = exports.default = SIAPageTop;